import { clientDetection } from '../app/shared/globalFunctions/globalFunctions';
import { baseEnvironment } from './environment.base';

export const environment = {
    ...baseEnvironment,
    API_URL: {
        CNMI: 'https://cnmitest2.newworldnow.com/v7/api',
        MI: 'https://mitest2.newworldnow.com/v7/api',
        MN: 'https://mntest2.newworldnow.com/v7/api',
        MO: 'https://motest2.newworldnow.com/v7/api',
        MT: 'https://mttest2.newworldnow.com/v7/api',
        ND: 'https://ndtest2.newworldnow.com/v7/api',
        NY: 'https://nytest2.newworldnow.com/v7/api',
        OK: 'https://oktest2.newworldnow.com/v7/api',
        PA: 'https://patest2.newworldnow.com/v7/api',
        PAEI: 'https://paeitest2.newworldnow.com/v7/api',
        SC: 'https://sctest2.newworldnow.com/v7/api',
        WI: 'https://witest2.newworldnow.com/v7/api',
    } as Record<string, string>,
    authority: 'https://identitytest.newworldnow.com',
    redirectUrl: `https://${clientDetection().toLowerCase()}-test.rostersync.newworldnow.com/callback`,
    clientId: `Training Provider ${clientDetection()} PWA(Dev)`, //CREATE MAPPING BETWEEN REDIRECT AND CLIENT ID
};